
import TagCross from "../../../assets/duotone/TagCross.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TagCrossIcon({ className, dataTestid = "TagCrossIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <TagCross data-testid={dataTestid} className={classes} {...rest} />
  );
}
